import React, { useState } from 'react';
import { Row, Col, Tag, Table, Button } from "antd";

import { FormatNumber } from '../../ValueObjects';

export default function TabDetalheItens({ itensNF }) {

    const [percentualDesc, setPercentualDesc] = useState(true);

    function retornarPercentual(perc_desconto, nfi_valordesconto) {
        if (percentualDesc) {
            return (
                <div>
                    <b>{perc_desconto}</b>%
                </div>
            )
        } else {
            return (
                <div>
                    <b>{FormatNumber(nfi_valordesconto, true)}</b>
                </div>
            )
        }
    };

    return (
        <div className="tabela">
            <Table dataSource={itensNF} columns={
                [
                    {
                        title: '',
                        render: ({ pro_codigo, pro_descricao, atributos }) => (
                            <div>
                                <Row align="middle" gutter={[5, 5]}>
                                    <Col>
                                        <Tag color="processing" className="w-100">
                                            <b>{pro_codigo}</b>
                                        </Tag>
                                    </Col>
                                    <Col>
                                        <b>{pro_descricao}</b>
                                    </Col>
                                    {!!atributos &&
                                        <Col>
                                            <Tag color="default">
                                                <b>{atributos.mgp_descricao}</b>
                                            </Tag>
                                        </Col>
                                    }
                                </Row>
                            </div>
                        ),
                    },
                    {
                        title: 'Quant.',
                        width: 80,
                        align: 'center',
                        render: ({ nfi_qtde, nfi_unidademedida }) => (
                            <div>
                                <Row align="middle" justify="center">
                                    <Col>
                                        <b>{nfi_qtde} {nfi_unidademedida}.</b>
                                    </Col>
                                </Row>
                            </div>
                        ),
                    },
                    {
                        title: 'Valor  Unit. (R$)',
                        align: 'right',
                        width: 100,
                        render: ({ nfi_valorunitario }) => (
                            <div>
                                <b>{FormatNumber(nfi_valorunitario, true)}</b>
                            </div>
                        ),
                    },
                    {
                        title: () => {
                            return (
                                <div>
                                    <Row align="middle" justify="end" gutter={[5, 0]}>
                                        <Col>
                                            Desc.
                                        </Col>
                                        <Col>
                                            <Button size="small" onClick={() => { setPercentualDesc(!percentualDesc) }}>{(percentualDesc ? '%' : 'R$')}</Button>
                                        </Col>
                                    </Row>
                                </div>
                            )
                        },
                        width: 100,
                        align: 'right',
                        render: ({ perc_desconto, nfi_valordesconto }) => (
                            retornarPercentual(perc_desconto, nfi_valordesconto)
                        ),
                    },
                    {
                        title: 'Total (R$)',
                        align: 'right',
                        width: 100,
                        render: ({ nfi_valorunitario }) => (
                            <div>
                                <b>{FormatNumber(nfi_valorunitario, true)}</b>
                            </div>
                        ),
                    }
                ]
            } />
        </div>
    );
}